import {
	Building2,
	Calendar,
	CheckSquare,
	DollarSign,
	FileText,
	KeyRound,
	LayoutDashboard,
	Megaphone,
	Receipt,
	Settings,
	Smartphone,
	Umbrella,
	UserCog,
	Users,
	UtensilsCrossed,
} from "lucide-react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import type { RootState } from "../../app/store";
import { AdminModuleKey } from "../../features/auth/adminModules";
import { canAccessNavItem } from "../../features/auth/moduleAccess";
import { cn } from "../../lib/utils";

const navigation = [
	{ name: "Dashboard", href: "/dashboard", icon: LayoutDashboard },
	{
		name: "PHO User Management",
		moduleKey: AdminModuleKey.USER_MANAGEMENT,
		href: "/users",
		icon: Users,
	},
	{
		name: "Properties",
		moduleKey: AdminModuleKey.PROPERTY_MANAGEMENT,
		href: "/properties",
		icon: Building2,
	},
	{
		name: "Event Management",
		moduleKey: AdminModuleKey.EVENT_MANAGEMENT,
		href: "/events",
		icon: Calendar,
	},
	{
		name: "Property Marketing",
		moduleKey: AdminModuleKey.PROPERTY_MARKETING,
		href: "/property-marketing",
		icon: Megaphone,
	},
	{
		name: "Cabana Management",
		moduleKey: AdminModuleKey.CABANA_MANAGEMENT,
		href: "/cabana-booking",
		icon: Umbrella,
	},
	{
		name: "F&B Management",
		moduleKey: AdminModuleKey.FNB_MANAGEMENT,
		href: "/restaurant-booking",
		icon: UtensilsCrossed,
	},
	{
		name: "Beneficiary Approvals",
		moduleKey: AdminModuleKey.BENEFICIARY_APPROVALS,
		href: "/approvals",
		icon: CheckSquare,
	},
	// {
	// 	name: "Charges Management",
	// 	href: "/charges-management",
	// 	icon: Receipt,
	// },
	// {
	// 	name: "Revenue Management",
	// 	href: "/revenue-management",
	// 	icon: DollarSign,
	// },
	{
		name: "Roles and Permissions",
		moduleKey: AdminModuleKey.ROLES_AND_PERMISSIONS,
		href: "/roles-permissions",
		icon: KeyRound,
	},
	{
		name: "Kerzner Sub Admin Management",
		moduleKey: AdminModuleKey.KERZNER_SUB_ADMIN,
		href: "/sub-admin",
		icon: UserCog,
	},
	{
		name: "App Update",
		moduleKey: AdminModuleKey.APP_UPDATE,
		href: "/app-update",
		icon: Smartphone,
	},
	{
		name: "Static Content",
		moduleKey: AdminModuleKey.STATIC_CONTENT,
		href: "/static-content",
		icon: FileText,
	},
	{ name: "Settings", href: "/settings", icon: Settings },
];

export const Sidebar = () => {
	const location = useLocation();
	const user = useSelector((state: RootState) => state.auth.user);

	return (
		<aside className="flex min-h-0 w-[var(--width-sidebar)] shrink-0 flex-col overflow-hidden border-r border-border bg-bg-card">
			<div className="shrink-0 px-6 py-5">
				<div className="text-xl font-bold leading-7 text-primary">
					Private Homes
				</div>
				<div className="mt-0.5 text-xs leading-4 text-primary-muted">
					Admin Portal
				</div>
			</div>
			<nav className="min-h-0 flex-1 space-y-1 overflow-y-auto px-4 pb-4">
				{navigation.map((item) => {
					if (!canAccessNavItem(user, item)) {
						return null;
					}
					const isActive =
						location.pathname === item.href ||
						(item.href !== "/" &&
							location.pathname.startsWith(`${item.href}/`));
					return (
						<Link
							key={item.name}
							to={item.href}
							className={cn(
								"flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium transition-colors",
								isActive
									? "bg-accent text-white"
									: "text-nav-inactive hover:bg-[var(--color-role-homeowner-bg)] hover:text-accent",
							)}
						>
							<item.icon className="h-5 w-5 shrink-0" />
							{item.name}
						</Link>
					);
				})}
			</nav>
		</aside>
	);
};
